import type { Theme } from '@emotion/react'
import { css } from '@emotion/react'
import { fontSize, size, width } from '@twistopayments/design-system/styles'

export const categories = css`
  margin: ${size[28]} auto ${size[36]};
  max-width: ${width.container.standard};
  display: flex;
  align-items: center;
  gap: ${size[12]};
`

export const category = (theme: Theme) => css`
  background-color: transparent;
  border: none;
  color: ${theme.palette.tertiary.mediumContrastAlternative};
  font-size: ${fontSize.lg};
  font-weight: 500;
  cursor: pointer;
`

export const activeCategory = (theme: Theme) => css`
  position: relative;
  color: ${theme.palette.text.title};

  &::after {
    position: absolute;
    content: '';
    width: 100%;
    height: 4px;
    bottom: -10px;
    left: 0;
    background-color: ${theme.palette.primary.mainContrast};
    border-top-left-radius: ${theme.borderRadius.sm};
    border-top-right-radius: ${theme.borderRadius.sm};
  }
`
